export default "__VITE_ASSET__DzV$nQC$__"